function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.8,5.2C14.8,5.1,14.8,5.1,14.8,5.2C14.7,5.1,14.7,5,14.7,5l-4.2-4.3c0,0,0,0,0,0c0,0-0.1-0.1-0.2-0.1c0,0,0,0,0,0 c-0.1,0-0.1,0-0.2,0H1C0.7,0.5,0.5,0.7,0.5,1v18.3c0,0.3,0.2,0.5,0.5,0.5h8.3v-1H1.5V1.5h8.2v3.8c0,0.3,0.2,0.5,0.5,0.5h3.7v3h1V5.3 C14.8,5.3,14.8,5.2,14.8,5.2z M10.7,2.2l2.5,2.6h-2.5V2.2z M15.2,21.5c-3,0-5.5-2.6-5.5-5.7s2.5-5.7,5.5-5.7c3,0,5.5,2.6,5.5,5.7 S18.2,21.5,15.2,21.5z M15.2,11.1c-2.5,0-4.5,2.1-4.5,4.7c0,2.6,2,4.7,4.5,4.7s4.5-2.1,4.5-4.7C19.7,13.2,17.6,11.1,15.2,11.1z  M17.4,16.6l-1.8,1.9c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.3-0.1-0.4-0.2c0,0,0,0,0,0L13,16.6 c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0l1,1v-3.5c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v3.5l1-1c0.2-0.2,0.5-0.2,0.7,0 C17.5,16,17.6,16.4,17.4,16.6z"
});

var SvgDownloadDoc = function SvgDownloadDoc(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21 22",
    style: {
      enableBackground: "new 0 0 21 22"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDownloadDoc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/downloadDoc.392b67e2.svg";
export { ForwardRef as ReactComponent };